"use client"

import ReactMarkdown from "react-markdown"
import type { Components } from "react-markdown"

import { cx } from "@uui/utils/cx"

interface RichTextProps {
  content: string
  className?: string
}

const components: Components = {
  // ReactMarkdown converts double-newlines to paragraph breaks and
  // single-newlines to spaces. Avoid `whitespace-pre-wrap` here; it
  // produces jagged mid-paragraph wrapping when source prose uses
  // editor-style 80-col line wrapping.
  p: ({ children }) => <p className="text-secondary">{children}</p>,
  blockquote: ({ children }) => (
    <figure className="my-6">
      <blockquote className="border-brand-solid text-primary border-l-2 pl-5 text-lg italic md:pl-6 md:text-xl">
        {children}
      </blockquote>
    </figure>
  ),
  strong: ({ children }) => (
    <strong className="text-primary font-semibold">{children}</strong>
  ),
  em: ({ children }) => <em className="italic">{children}</em>,
  a: ({ href, children }) => (
    <a
      href={href}
      className="text-brand-secondary hover:text-brand-secondary_hover underline underline-offset-2"
    >
      {children}
    </a>
  ),
}

export function RichText({ content, className }: RichTextProps) {
  return (
    <div className={cx("flex flex-col gap-4", className)}>
      <ReactMarkdown components={components}>{content}</ReactMarkdown>
    </div>
  )
}
